import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";

export const createSignalRConnection = (userName) => {
  return new HubConnectionBuilder()
    .withUrl(`${process.env.REACT_APP_SIGNALR_URL}/fap?userName=${encodeURIComponent(userName)}`)
    .configureLogging(LogLevel.Information)
    .withAutomaticReconnect()
    .build();
};